import { CookieConsentBanner } from '@/features/cookie-consent/components/CookieConsentBanner';
import { CookiePreferencesModal } from '@/features/cookie-consent/components/CookiePreferencesModal';
import { CookieSettingsLauncher } from '@/features/cookie-consent/components/CookieSettingsLauncher';
import { useCookieConsentStore } from '@/stores/cookie-consent-store';

/**
 * App-wide cookie consent UI: the first-visit banner, the preferences modal
 * it (and the settings launcher) open, and the launcher itself once a
 * decision has been made. Mount once near the app root.
 */
export function CookieConsentManager() {
  const hasDecided = useCookieConsentStore((s) => s.preferences !== null);

  return (
    <>
      {!hasDecided && <CookieConsentBanner />}
      {hasDecided && <CookieSettingsLauncher />}
      <CookiePreferencesModal />
    </>
  );
}
